var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.37 281.903L436.352 118.944C424.869 113.655 412.638 110.986 400 110.986C387.362 110.986 375.134 113.655 363.648 118.944L9.62969 281.903C3.77813 284.608 0 290.503 0 296.945C0 303.387 3.77813 309.283 9.62969 311.987L363.648 474.947C375.131 480.236 387.362 482.917 400 482.917C412.638 482.917 424.869 480.236 436.355 474.947L715.748 346.344V475.845C704.661 477.095 696.014 486.533 696.014 497.936C696.014 507.872 702.589 516.473 711.961 519.214L693.067 643.887H780.061L761.17 519.214C770.539 516.473 777.114 507.872 777.114 497.936C777.114 486.533 768.467 477.095 757.38 475.845V327.177L790.373 311.987C796.223 309.283 800.003 303.387 800.003 296.945C800.003 290.503 796.222 284.608 790.37 281.903Z",
    fill: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 541.923C382.428 541.923 365.402 538.187 349.397 530.823L176.239 451.109V609.919C176.239 644.784 281.592 689.014 400 689.014C518.409 689.014 623.764 644.783 623.764 609.919V451.109L450.597 530.823C434.602 538.187 417.578 541.923 400 541.923Z",
    fill: "#5D5D5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheme);
export default __webpack_public_path__ + "static/media/scheme.0e11e0a8a5b25b520d4644d83ee5d77a.svg";
export { ForwardRef as ReactComponent };